import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';

import { consts as managePendingAppoinmentsConsts } from '../../healthboard/requests/manage-pending-request';
import { consts as cancelAppointmentConsts } from '../../healthboard/requests/cancel-appointment-req';
import { consts as changeStatusAppointmentConsts } from '../../healthboard/requests/status-change-req';
import { APPOINTMENT_STATUSES } from '../../../constants';
import { SCHEDULE_VALIDATE_TYPES } from '../validate';

export const consts = createReqConsts('schedule', 'search', ['INIT_LOAD']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'provider',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'calendar',
    'schedule',
    {
      type: 'payload.query',
      queryParameter: 'start_on',
      selector: 'startOn',
    },
    {
      type: 'payload.query',
      queryParameter: 'end_on',
      selector: 'endOn',
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
  workSlots: [],
  blockedSlots: [],
  appointments: [],
};

const cancelledStatuses = [
  APPOINTMENT_STATUSES.CANCELED,
  APPOINTMENT_STATUSES.DECLINED,
];

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case changeStatusAppointmentConsts.SUCCEED:
    case managePendingAppoinmentsConsts.SUCCEED: {
      const appointments = state.appointments.reduce((list, appointment) => {
        if (appointment.id === payload.id) {
          const status = get(payload, 'status.coreAppName');
          const isCancelled = cancelledStatuses.includes(status);

          return isCancelled
            ? list
            : [...list, { ...appointment, status: payload.status }];
        }
        return [...list, appointment];
      }, []);

      return {
        ...state,
        appointments,
      };
    }

    case cancelAppointmentConsts.SUCCEED: {
      const appointments = state.appointments.filter(
        ({ id }) => id !== payload.id,
      );

      return {
        ...state,
        appointments,
      };
    }

    case SCHEDULE_VALIDATE_TYPES.CLEAR: {
      return { ...initialState };
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/schedule-search-req.js